/**
 * A largura de um elemento em pixel, medida pelo `ResizeObserver` (onda 313, R4): o visual desenha o SVG
 * em pixel — 12 px é 12 px no celular e no monitor —, nunca esticado por `viewBox`. Sem `ResizeObserver`
 * (um navegador antigo, o teste), mede uma vez.
 */
import { useLayoutEffect, useRef, useState } from 'react';
import type { RefObject } from 'react';

/** A referência para pôr no elemento e a largura dele (0 antes da primeira medida). */
export function useLargura<T extends Element>(): [RefObject<T | null>, number] {
  const ref = useRef<T>(null);
  const [largura, setLargura] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const medir = (): void => {
      const w = Math.floor(el.getBoundingClientRect().width);
      setLargura((antes) => (antes === w ? antes : w));
    };
    medir();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observador = new ResizeObserver(medir);
    observador.observe(el);
    return () => observador.disconnect();
  }, []);
  return [ref, largura];
}
